<template>
  <section class="task-wrap" :style="dBHeight">
    <modals-container @afterAdd="afterAdd"/>
    <div class="tab_ty1">
      <AuditTab :currentTab="3" />
      <div class="tab-content">
          <div class="tab_ty2">
            <AuditSubTab :currentTab="3" :currentTab2="0" />
            <div class="tab-content" >
              <div class="admin-hash-tag"> 
                <div class="organization-area" :style="height">
                  <TodoDeptUserList
                      @selectUser="selectUser"
                      @deSelectUser="deSelectUser"
                      @clickSelectUser="clickSelectUser"
                  />
                </div>
                <div class="selected-area">
                  <ul class="list-table">
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("entity.user.deptName","부서")}}</dt>
                        <dd style="width: 83%;">
                          <div class="input-box">
                            <input type="text" :placeholder="$i18nUtil.trans('entity.user.deptName.002','부서명')" disabled style="width: 70%; background-color: white; color: black;" v-model="deptName">
                          </div>
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("entity.user.user")}}</dt>
                        <dd style="width: 83%;">
                          <div class="input-box">
                            <input type="text" :placeholder="$i18nUtil.trans('message.RoleUserRegist.001','사용자명')" disabled style="width: 70%; background-color: white; color: black;" v-model="addUserNameList"> 
                          </div>
                        </dd>
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt>{{$i18nUtil.trans("message.TodoDeptUserRegist.001","타입")}}</dt>
                        <dd>
                          <div class="radio-box">
                            <div v-if="beforeUserType == 'DEFAULT'">
                            <input type="radio" name="DfUser" id="DfUser" value="DEFAULT" v-model="userType"><label for="DfUser">DEFAULT</label>
                            <input type="radio" name="ExUser" id="ExUser" value="EXCLUDE" v-model="userType"><label for="ExUser">EXCLUDE</label>
                            </div>
                            <div v-else-if="beforeUserType == 'EXCLUDE'">
                            <input type="radio" name="ExUser" id="ExUser" value="EXCLUDE" v-model="userType"><label for="ExUser">EXCLUDE</label>
                            </div>
                            <div v-else-if="beforeUserType == 'INCLUDE'">                            
                            <input type="radio" name="InUser" id="InUser" value="INCLUDE" v-model="userType"><label for="InUser">INCLUDE</label>                            
                            </div>
                          </div>
                        </dd>
                      </dl>
                    </li>
                  </ul>
                  <div class="footer" style="padding-top: 5%;">
                    <button type="button" class="btn-primary-medium black" @click="addUser" >{{$i18nUtil.trans("button.add","추가")}}</button>
                    <button type="button" class="btn-primary-medium black" @click="updateUser" v-if="beforeUserType == 'DEFAULT'">{{$i18nUtil.trans("button.save","저장")}}</button> 
                    <button type="button" class="btn-primary-medium black" @click="delUser" v-if="beforeUserType == 'INCLUDE' || beforeUserType == 'EXCLUDE'">{{$i18nUtil.trans("button.delete","삭제")}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import TodoDeptUserList from "./TodoDeptUserList";
import AuditSubTab from "./AuditSubTab";
import AuditTab from "./AuditTab";
import EventBus from "@/js/eventbus/eventBus";
import TodoDeptUserRegist from "./modal/TodoDeptUserRegist";

export default {
    name: "tabs",
    props: ["modalInfo"],
    components: {
        TodoDeptUserList,
        AuditSubTab,
        AuditTab
    },
    data() {
        return {
            dBHeight: {
                'min-height': (window.innerHeight - 154) + 'px',
            },
            height: {
                'height': (window.innerHeight - 154) + 'px',
            },
            toastInfo: {
              obj: this.$toasted,
              message: "",
              options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000,
              },
            },
            deptName : '',
            deptId : '',
            userName : '',
            userId : '',
            userType : 'DEFAULT',
            beforeUserType : 'DEFAULT',
            checkUsers : [],
            addUserNameList : [],
            addUserIdList : [],
            treeNode : null,
        };
    },
    created(){
      EventBus.$off("setDept");
      EventBus.$on("setDept", param => {
        let obj = this;
        obj.deptName = param.deptName;
        obj.deptId = param.deptId;
        obj.treeNode = param.node;
      });
    },
    watch: {
      deptName() {
        this.addUserNameList = [];
        this.addUserIdList = '';
      },
    },
    methods: {
        ...mapActions("modals", ["showToast", "showModal"]),
        /* rest Call&CallBack Action */
        ...mapActions("restAction", ["COWORK_REST_ACTION"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* 추가 버튼 클릭 시 */
        addUser(){
          let obj = this;
          if(obj.deptName == ''){
            obj.toastInfo.message = obj.$i18nUtil.trans("message.CwpoRegist.002","부서를 선택해 주세요.");
            obj.showToast(obj.toastInfo);
          } else {
            const modalInfo = {
            obj: obj.$modal,
            component: TodoDeptUserRegist,
            width: "600px",
            height: "400px",
            deptName : obj.deptName,
            deptId : obj.deptId,
            treeNode : obj.treeNode,
            };
            obj.showModal(modalInfo);
          }
        },
        /* 저장 버튼 클릭 시 */
        updateUser() {
          let obj = this;
          if(obj.addUserNameList.length < 1){
            obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.003","사용자를 선택해 주세요.");
            obj.showToast(obj.toastInfo);
          } else {
            if(confirm(obj.$i18nUtil.trans("message.TodoDeptUser.001","해당 사용자의 타입을 변경하여 저장하시겠습니까?"))) {
              if(obj.userType == obj.beforeUserType) {
                obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUser.002","사용자의 타입이 변경 되었습니다.");
                obj.showToast(obj.toastInfo);
              } else {
                let reqData = {
                  url : "/api/copaper/todo/updateTodoDeptUserList",
                  method : "post",
                  params : {
                    saveUserId : obj.addUserIdList,
                    userType : obj.userType,
                    deptId : obj.deptId,
                  }
                };
                obj.COWORK_REST_SIMPLE_ACTION(reqData)
                  .then(function (res) {
                    if(res.errorCode !== null) {
                      console.log(res.errorCode);
                    } else {
                      obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUser.002","사용자의 타입이 변경 되었습니다.");
                      obj.showToast(obj.toastInfo);
                      obj.refreshTreeNode(obj.treeNode);
                    }
                  })
                  .catch(function (err) {
                    console.log(err);
                });
              }
            }
          }
        },
        /* 삭제 버튼 클릭 시 */
        delUser(){
          let obj = this;
          if(obj.checkUsers.length == 0){
            obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUser.003","삭제하려는 사용자를 체크 해주시기 바랍니다.");
            obj.showToast(obj.toastInfo);
          }
          else if(confirm(obj.$i18nUtil.trans("message.TodoDeptUser.004","선택하신 사용자를 삭제하시겠습니까?"))) {
            let deleteUserList = [];
            for(let idx in obj.checkUsers){
              if(obj.checkUsers[idx].USER_TYPE != 'DEFAULT'){
                deleteUserList.push(obj.checkUsers[idx].USER_ID);
              }
            }
            if(deleteUserList.length < 1) { // DEFAULT 사용자만 삭제하려는 경우.
              obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUser.005","DEFAULT 사용자는 삭제가 불가능 합니다.");
              obj.showToast(obj.toastInfo);
              return;
            }
            let reqData = {
                url : "/api/copaper/todo/deleteTodoDeptUserList",
                method : "post",
                params : {
                  delUserId : deleteUserList,
                  deptId : obj.deptId,
                }
            };
            obj.COWORK_REST_SIMPLE_ACTION(reqData)
              .then(function (res) {
                if(res.errorCode !== null) {
                  console.log(res.errorCode);
                } else {
                  obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUser.006","해당 사용자가 삭제 되었습니다.");
                  obj.showToast(obj.toastInfo);              
                  obj.refreshTreeNode(obj.treeNode);
                  obj.checkUsers = [];
                }
              })
              .catch(function (err) {
                console.log(err);
            });
          }
        },
        selectUser(param) {
          this.target = param.target;
          if(param.type === "ALL") {
            this.checkUsers = param.data;
          } else {
            this.checkUsers.push(param.data);
          }
        },
        deSelectUser(user) {
          let checkUsers = this.checkUsers;
          if(user.type === "ALL") {
            this.checkUsers = [];
          } else {
            checkUsers = checkUsers.filter(function (item) {
            return item.userId !== user.data.userId;
            });
            this.checkUsers = checkUsers;
          }
        },
        /* 좌측의 사용자 목록에서 사용자 클릭 시 */
        clickSelectUser(param) {
          let obj = this;          
          obj.addUserNameList = [];
          obj.addUserIdList = [];
          obj.addUserNameList.push(param.name);
          obj.addUserIdList.push(param.id);
          obj.userType = param.type;
          obj.beforeUserType = param.type;
        },
        /* 트리 목록 새로고침 */
        refreshTreeNode(node) {
          let obj = this;
          let reqData = {
            url : "/api/copaper/todo/getTodoDeptUserList",
            method : "post",
            params : {
              deptId : node.id
            }
          };
          this.COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function (res) {
              if(res.errorCode !== null) {
                console.log(res.errorCode);
              } else {
                obj.deptName = node.label,
                obj.deptId = node.id,
                obj.addUserNameList = [],
                obj.addUserIdList = [],
                obj.userType = 'DEFAULT';
                obj.beforeUserType = 'DEFAULT';
                obj.setTreeOfUserList(res.result);
              }
            })
            .catch(function (err) {
              console.log(err);
            });
        },
        setTreeOfUserList(result) {
          if (result !== null) {
            EventBus.$emit("afterSave", {
              userList: result,
              userCount: result.length,
            });
          } else {
            EventBus.$emit("afterSave", {
              userList: {},
              userCount: 0,
            });
          }
        },
        /* 신규 사용자 추가 시 */
        afterAdd(){
          this.refreshTreeNode(this.treeNode);
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/TodoDeptUser.vue